<template>
  <div class="table-manage">
    <el-card shadow="never" class="table-card">
      <template #header>
        <div class="card-header">
          <div class="floor-tabs">
            <el-button
              v-for="floor in allTableStore.category"
              :key="floor"
              :type="activeCategory === floor ? 'primary' : 'default'"
              size="small"
              @click="filterByCategory(floor)"
            >
              {{ floor }}
            </el-button>
          </div>
        </div>
      </template>

      <div class="table-grid">
        <el-row :gutter="10">
          <el-col
            v-for="table in filteredTables"
            :key="table.tableNo"
            :xs="24"
            :sm="12"
            :md="8"
            :lg="4"
          >
            <el-card class="table-card-item" shadow="hover" :body-style="{ padding: '12px' }" @click="goToTableDetail(table)">
              <div class="table-info">
                <div class="table-header">
                  <h3 class="table-name">{{ table.tableNo }}</h3>
                  <div class="table-header-tags">
                    <el-tag size="small" type="info" effect="plain">{{ table.floor }}</el-tag>
                    <el-tag :type="table.customerCnt !== 0 ? 'warning' : 'success'" size="small">
                      {{ table.customerCnt !== 0 ? '用餐中' : '空闲' }}
                    </el-tag>
                  </div>
                </div>
                <div class="table-meta">
                  <div class="meta-item">
                    <span class="meta-label">人数</span>
                    <span class="meta-value">{{ table.customerCnt || 0 }}/{{ table.capacity }}</span>
                  </div>
                  <div class="meta-item">
                    <span class="meta-label">类型</span>
                    <span class="meta-value">{{ table.type }}</span>
                  </div>
                </div>
                <div class="table-duration" :class="{ 'empty': table.customerCnt === 0 }">
                  <span class="duration-label">用餐时长</span>
                  <span class="duration-value">
                    {{ table.customerCnt !== 0 ? tzDayjs.formatDuration(table.startTime) : '—' }}
                  </span>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { onMounted, ref, computed, onUnmounted } from 'vue'
import { useAllTableStore } from '@/stores/admin/allTableStore'
import { useTableStore } from '@/stores/common/tableStore'
import sseService from '@/utils/sseService'
import { useRouter } from 'vue-router'
import tzDayjs from '@/utils/dayjs'

const router = useRouter()
const allTableStore = useAllTableStore()
const tableStore = useTableStore()
const activeCategory = ref('全部')

// 根据分类过滤菜品
const filteredTables = computed(() => {
  if (activeCategory.value === '全部') return allTableStore.tables
  return allTableStore.tables.filter(table => table.floor === activeCategory.value || table.type === activeCategory.value)
})

const filterByCategory = (category) => {
  activeCategory.value = category
}

// 跳转到桌台详情页
const goToTableDetail = (table) => {
  tableStore.updateState(table)
  router.push('/admin/table-detail')
}

const sseCallback = async (e) => {
  await allTableStore.getAllTables()
  console.log(e)
}

// 加载数据
onMounted(async () => {
  await allTableStore.getAllTables()
  sseService.on('table-updated', (e) => {
    sseCallback(e)
  })
})

onUnmounted(() => {
  sseService.off('table-updated')
})
</script>

<style scoped>.table-manage {
  width: 100%;
}

.table-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.floor-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.floor-tabs .el-button {
  margin-left: 0;
}

.table-grid {
  margin-top: 20px;
}

.table-card-item {
  border-radius: 8px;
  transition: transform 0.2s, box-shadow 0.2s;
  margin-bottom: 16px;
}

.table-card-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.table-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-name {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.table-meta {
  display: flex;
  justify-content: space-between;
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 8px 10px;
}

.meta-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.meta-label {
  font-size: 12px;
  color: #999;
}

.meta-value {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.table-duration {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #666;
  background-color: #fff9e6;
  border-radius: 4px;
  padding: 6px 10px;
}

.duration-label {
  color: #b37400;
}

.duration-value {
  font-weight: 500;
  color: #b37400;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.table-header-tags {
  display: flex;
  gap: 6px;
  align-items: center;
}

.table-duration {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  background-color: #fff9e6;
  border-radius: 4px;
  padding: 6px 10px;
  min-height: 32px; /* 保证高度一致 */
  box-sizing: border-box;
}

.table-duration.empty {
  background-color: #f5f5f5;
  color: #ccc;
}

.table-duration.empty .duration-label {
  color: #999;
}

.table-duration.empty .duration-value {
  color: #ccc;
}

.duration-label {
  color: #b37400;
}

.duration-value {
  font-weight: 500;
  color: #b37400;
}
</style>